// extracted by mini-css-extract-plugin
module.exports = {"cimHeader":"cim-header_cimHeader__hHYsE","loadingContent":"cim-header_loadingContent__Fk5as shimmer-animation","right":"cim-header_right__6K593"};